import { BrowserRouter, Routes, Route } from "react-router-dom"
import AuthRouter from './routers/AuthRouter'
import { AuthProvider } from './components/auth/useAuth'
import PrivateTeacherRouter from './routers/TeacherPrivateRouter'
import TeacherRouter from './routers/TeacherRouter'
import ChangePassword from './pages/auth/ChangePassword'

export default function App() {
	return (
		<>
			<BrowserRouter>
				<AuthProvider>
					<Routes>
						<Route path="/teacher/change-password" element={ <PrivateTeacherRouter><ChangePassword /></PrivateTeacherRouter>} />
						<Route path="/teacher/*" element={ <PrivateTeacherRouter><TeacherRouter /></PrivateTeacherRouter>} />
						<Route path="*" element={<AuthRouter />}/>
					</Routes>
				</AuthProvider>
			</BrowserRouter>
		</>
	)
}
